/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const backfillIndexnowV1ResultSchema = z.object({
  started: z.boolean(),
});

export type IBackfillIndexnowV1Result = z.infer<typeof backfillIndexnowV1ResultSchema>;

export const backfillIndexnowV1ResponseSchema = createApiResponseSchema(
  backfillIndexnowV1ResultSchema,
) as z.ZodSchema<IAPI<IBackfillIndexnowV1Result>>;

export type IBackfillIndexnowV1Response = IAPI<IBackfillIndexnowV1Result>;
